export enum NotificationType {
 Default = 0,
 AOAmend = 1,
 AOAmendAccept = 2,
 AOAmendReject = 3,
 EnCreated = 4,
 EnEdited = 5,
 EnActivity = 6,
 ExpansionApplicationMessage = 7,
 ExpansionApplicationAERRequested = 8,
 ExpansionApplicationWithdraw = 9,
 ExpansionApplicationUpdated = 10,
 ExpansionApplicationCompleted = 11,
 ExpansionApplicationCreated = 12,
 ExpansionApplicationAssigned = 13,
 ExpansionApplicationAERComplete = 14,
 AOMessage = 15,
 AODocument = 16,
 AOClose = 17,
 AOReopen = 18,
 AOCreateRelease = 19,
 AOOrgAssigned = 20,
 RecognitionResponseDoc = 21,
 RecognitionResponseMessage = 22,
 RecognitionApplicationCreated = 23,
 RecognitionApplicationReviewerAssigned = 24,
 RecognitionInitialRegistration = 25,
 InformationRequestSent = 26,
 InformationRequestAssignedOfqual = 27,
 InformationRequestUpdated = 28,
 InformationRequestRecipientAdded = 29,
 InformationRequestMessageFromOfqual = 30,
 InformationRequestMessageFromAO = 31,
 InformationRequestAssignedAO = 32,
 InformationRequestActionResponse = 33,
 InformationRequestClosed = 34,
 CtrAssigned = 35,
 CtrMessageRegulator = 36,
 CtrMessageAO = 37,
 CtrCreated = 38,
 CtrClosed = 39,
 QualificationCreatedAccredited = 40,
 QualificationMessageCreated = 41,
 QualificationApproved = 42,
 QualificationRejected = 43,
 ComplaintCreated = 44,
 ComplaintClosed = 45,
 ComplaintCommsCitizen = 46,
 ComplaintInternalReviewCitizen = 47,
 ComplaintStageUpdated = 48,
 ComplaintCaseLeadAssigned = 49,
 ComplaintAssigned = 50,
 ComplaintTransfer = 51,
 ComplaintInternalMessage = 52,
 InformationRequestDeleteAO = 53,
 ApqReopen = 53,
 ApqMessageFromAo = 54,
 ApqMessageFromOfqual = 55,
 ApqAttachment = 56,
 ApqClosedAo = 57,
 ApqFromCtr = 58,
 PeInternalMessage = 59,
 RecognitionApplicationRejectNotification = 60,
 FoiInternalMessage = 1001,
 FoiAssigned = 1002,
 FoiCreatedFromPublicEnquiry = 1003,
 FoiCreatedFromSar = 1004,
 FoiEventRecipient = 1005,
 FoiCreatedByCitizen = 1007,
 FoiTransferFromPE = 1008,
 FoiEventComplete = 1009,
 SocInternalMessage = 2000,
 SocAssign = 2001,
 SocSent = 2002,
 SocMessage = 2003,
 SocClosed = 2004,
 PeCitizenCreatePe = 3000,
 PeTransferredFromFoi = 3001,
 PeAssigned = 3002,
 PublicMessage = 4000,
 LcmInternalMessage = 6001,
 LcmAssigned = 6002,
 LcmRejected = 6003,
 LcmExternalCounselRequest = 6004,
 LcmExternalCounselAccepted = 6005,
 LcmExternalCounselRejected = 6006,
 SmsInternalMessage = 9001,
 SmsEvaluationCompleted = 9100,
 SmsAssignedTo = 9002,
 SmsFurtherEvidenceNotification = 9003,
 SmsCitizenResponseToRequest = 9004,
 SmsCitzenSubmitRequest = 9005,
 SmsCitizenSendMessageRequest = 9006,
 SmsCitizenUpdateDetailChangeRequest = 9007
}
